interface AddNodeIconProps {
  size?: number;
}

/** "Add child node" plus-in-circle icon used by LBNodeDisplay's extension stem. */
export function AddNodeIcon({ size = 24 }: AddNodeIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='32' height='32' rx='16' fill='var(--surface-container)' />
      <path
        d='M16 6C10.48 6 6 10.48 6 16C6 21.52 10.48 26 16 26C21.52 26 26 21.52 26 16C26 10.48 21.52 6 16 6ZM21 17H17V21H15V17H11V15H15V11H17V15H21V17Z'
        fill='var(--light-blue)'
      />
    </svg>
  );
}
